export enum ErrorCodes {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  UNAUTHORIZED = 'UNAUTHORIZED',
  USER_DISABLED = 'USER_DISABLED',
  POPUP_BLOCKED = 'POPUP_BLOCKED',
  OAUTH_NO_WINDOW_OPENER = 'NO WINDOW OPENER',
  LICENSE_NOT_FOUND = 'LICENSE_NOT_FOUND',
  USER_PENDING = 'USER_PENDING',
}

export enum ErrorCodeApi {
  TICKETS_CLOSE_RESOLUTION_DATE = 'Tickets.ClosedDateNotAllowed',
  ORGANIZATION_ALREADY_EXISTS = 'Organization.AlreadyExists',
  ORGANIZATION_IDP_ALIAS_ALREADY_EXISTS = 'Organization.AliasIdp.AlreadyExists',
  EXCEPTION_MESSAGE = 'Exception.Message',
  // In case of BE is down or some other server error
  SERVER_FAILURE = 'Server.Failure',
  ORGA_NOT_CONFIG = 'Organization.RoleAdmin.NotConfig',
  USER_CANNOT_REMOVE_ORGA_ADMIN = 'User.Cannot.Remove.OrgaAdmin',
  USER_CANNOT_UPDATE_ITSELF = 'User.Cannot.Update.ItSelf',
  NO_RULES_TO_CALCULATE_RESOURCE_SLA = 'ResourceRules.Not.Found',
  ORGA_INTEGRATION_SAME_NAME = 'OrganizationIntegration.Integration.SameName',
  LICENSE_NOT_FOUND = 'License.NotFound',
  // error code copliant with standard https://datatracker.ietf.org/doc/html/rfc9457
  CREDITS_NOT_AVAILABLE = '/problems/credits-not-available',
}
